import React, { useState, useEffect, useRef, useMemo } from "react";
import { Card, Row, Col, Modal, Badge, Button, Select, Drawer, Checkbox, Input, Skeleton, message, Tooltip, Table, Radio } from "antd";
import { StarOutlined, CloseOutlined, CloseSquareFilled, CompassFilled, EyeOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { Scrollbars } from "react-custom-scrollbars";
import DefaultProductImage from "../../../assets/images/no-image.svg";
import "../../style.css";
import "./styles.css";
import db from "../../../database";
import { debounce } from "lodash";
import data from "../../../constants/retailPos.json";
import i18next from "i18next";
import locale from "antd/lib/date-picker/locale/en_US";
import tick from "../../../assets/images/tic.png";
import SearchIcon from "../../../assets/images/searchIcon.svg";
import MoreOptionsIcon from "../../../assets/images/moreOptionsIcon.svg";
import filterList from "../../../assets/images/filterList.svg";
import gridFilterInActive from "../../../assets/images/grid_filter2.svg";
import gridFilter from "../../../assets/images/grid_filter1.svg";
import Close from "../../../assets/images/close-x.svg";
import { getProductsNearbyStockService, generateTransferRequestService } from "../../../services";
import { Tabs } from "antd";
import { getApplicablePrice } from "../../../utility/getPriceList";

const colors = [
  { backgroundColor: "#ffedd5", borderColor: "#fdba74", hoverBackground: "#fed7aa" },
  { backgroundColor: "#ede9fe", borderColor: "#c4b5fd", hoverBackground: "#ddd6fe" },
  { backgroundColor: "#fce7f3", borderColor: "#f9a8d4", hoverBackground: "#fbcfe8" },
  { backgroundColor: "#fef9c3", borderColor: "#fde047", hoverBackground: "#fef08a" },
  { backgroundColor: "#ccfbf1", borderColor: "#5eead4", hoverBackground: "#99f6e4" },
  { backgroundColor: "#fee2e2", borderColor: "#f87171", hoverBackground: "#fecaca" },
];

const ProductPanelSM = (props) => {
  const {
    checkIsManualWeight,
    isProductsFilter,
    getMoreProducts,
    productListCardRef,
    selectProductInCart,
    productItems,
    setProductItems,
    productsDisplay,
    setIsProductsVisible,
    isProductsVisible,
    pickProduct,
    selectProductToCart,
    filterDrawer,
    setFilterDrawer,
    productSearchInput,
    setProductSearchInput,
    setOpen,
    productSearchInputRef,
    keyboardType,
    setKeyboardType,
    clearProductSearchResults,
    productsData,
    productSearchRef,
    handleSelectProduct,
    setProductsList,
    productsList,
    setLayoutName,
    productPanelSearchRef,
    setInputName,
    keyboard,
    searchInputRef,
    selectedProductInCart,
  } = props;
  const [displayBatchSelection, setDisplayBatchSelection] = useState(false);
  const [batchSetAvailable, setBatchSetAvailable] = useState([]);
  const [brandsData, setBrandsData] = useState([]);
  const [categoriesData, setCategoriesData] = useState([]);
  const tillData = JSON.parse(localStorage.getItem("tillData"));
  const posConfig = JSON.parse(localStorage.getItem("posConfig"));
  const [selectedProductBrand, setSelectedProductBrand] = useState([]);
  const [selectCategoryList, setSelectCategoryList] = useState([]);
  const [showArrows, setShowArrows] = useState(true);
  const scrollContainerRef = useRef(null);
  const [categoryCounts, setCategoryCounts] = useState({});
  const [loading, setLoading] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [originalProducts, setOriginalProducts] = useState(0);
  const [stockDrawerVisible, setStockDrawerVisible] = useState(false);
  const [selectedStockProduct, setSelectedStockProduct] = useState(null);
  const [stockLoading, setStockLoading] = useState(false);
  const [displayedNonFrequentProducts, setDisplayedNonFrequentProducts] = useState([]);
  const [hasMoreNonFrequent, setHasMoreNonFrequent] = useState(true);
  const [requestPopupVisible, setRequestPopupVisible] = useState(false);
  const [requestStoreName, setRequestStoreName] = useState("");
  const [requestFromBunitId, setRequestFromBunitId] = useState("");
  const [requestQty, setRequestQty] = useState(1);
  const [maxQty, setMaxQty] = useState(0);
  const [requestProductName, setRequestProductName] = useState("");
  const [selectedOutlet, setSelectedOutlet] = useState(null);
  const debounceTimeout = useRef(null);
  const ITEMS_PER_LOAD = 50;
  const currenciesList = tillData.tillAccess.csBunit.currencies;
  const { Option } = Select;
  const { TabPane } = Tabs;
  const [stockList, setStockList] = useState([]);
  const t = i18next.t;
  const [selectedStockRow, setSelectedStockRow] = useState(null);
  const filteredProducts = productsList.filter((item) => selectedCategory === "All" || item.category === selectedCategory);
  const frequentProducts = filteredProducts.filter((item) => item.isBestSeller);
  const nonfrequentProducts = filteredProducts.filter((item) => !item.isBestSeller);

  const buildTransferRequestMutation = ({ fromBunitId, toBunitId, productId, qty, userId }) => {
    // 🔥 current date & time
    const now = new Date();

    // YYYY-MM-DD
    const requiredDate = now.toISOString().split("T")[0];

    // YYYY-MM-DD HH:mm:ss.SSS
    const currentTimestamp = now.toISOString().replace("T", " ").replace("Z", "");

    const dataLoad = [
      {
        fromBunitId,
        toBunitId,
        created: currentTimestamp,
        createdby: userId,
        updated: currentTimestamp,
        updatedby: userId,
        requiredDate,
        requestFor: "ST",
        description: "",
        lines: [
          {
            productId,
            qtyRequested: qty,
            pRequisitionLineId: null,
          },
        ],
      },
    ];

    const dataLoadString = JSON.stringify(dataLoad).replace(/"/g, '\\"');

    return `
    mutation {
      generateTransferRequest(
        dataLoad: "${dataLoadString}"
      ) {
        message
        code
        recordId
      }
    }
  `;
  };

  useEffect(() => {
    if (filterDrawer) {
      setTimeout(() => {
        if (productPanelSearchRef.current) {
          productPanelSearchRef.current.focus();
        }
      }, 100);
    }
  }, [filterDrawer]);

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      await db.productCategories.toArray().then((res) => {
        const mappedCategories = res.map((item) => ({
          ...item,
          label: item.value,
          value: item.mProductCategoryId,
        }));
        const sortedCategories = mappedCategories.sort((a, b) => a.label.localeCompare(b.label));
        setCategoriesData(sortedCategories);
      });

      await db.productBrands.toArray().then((res) => {
        const mappedBrands = res.map((item) => ({
          ...item,
          label: item.name,
          value: item.brandId,
        }));
        const sortedBrands = mappedBrands.sort((a, b) => a.label.localeCompare(b.label));
        setBrandsData(sortedBrands);
      });

      await db.products
        .filter((product) => product.isactive === true)
        .toArray()
        .then((productsFetched) => {
        setOriginalProducts(productsFetched.length);
        const cartObj = JSON.parse(localStorage.getItem("cartObj"));

        const updatedProducts = productsFetched.map((product) => {
          const selectedPrice = getApplicablePrice({
            priceList: product.priceList,
            selectedUomId: product.uomData?.[0]?.csUomId,
            sPriceListId: cartObj?.customer?.sPriceListId,
          });

          if (selectedPrice) {
            return {
              ...product,
              sunitprice: selectedPrice.pricestd,
              slistprice: selectedPrice.pricestd,
            };
          }

          return product;
        });

        setProductsList(updatedProducts);
        setDisplayedNonFrequentProducts(updatedProducts.filter((item) => !item.isBestSeller).slice(0, ITEMS_PER_LOAD));
        setHasMoreNonFrequent(updatedProducts.filter((item) => !item.isBestSeller).length > ITEMS_PER_LOAD);
        const counts = updatedProducts.reduce((acc, product) => {
          const categoryId = product.mProductCategoryId || "uncategorized";
          acc[categoryId] = (acc[categoryId] || 0) + 1;
          return acc;
        }, {});
        setCategoryCounts(counts);
      });
      setLoading(false);
    };
    filterDrawer ? fetchData() : onFilterClose();
  }, [filterDrawer]);

  const getProductNearByStock = async (product) => {
    console.log("Fetching nearby stock for product:", product);
    setStockLoading(true);
    try {
      const stockInputValues = {
        query: `
        query {
          getProductsNearbyStock(
            bUnitId: "${tillData.tillAccess.csBunit.csBunitId}",
            code: "${product.value}"
          ) {
            csBunitId
            value
            name
            totalQty
            stores {
              csNearbyStoreId
              name
              nearbybUnitId
              viewStock
              isIssue
              warehouse {
                mWarehouseID
                name
                value
                storageBin {
                  mStoragebinID
                  name
                  stocks {
                    mStockID
                    qtyonhand
                    product {
                      mProductId
                      value
                      name
                      upc
                      uom {
                        csUomId
                        name
                      }
                      productCategory {
                        mProductCategoryId
                        value
                        name
                      }
                    }
                    batch {
                      mBatchId
                      batchno
                      upc
                      price
                      startdate
                      enddate
                      life
                      purchasePrice
                      listPrice
                      purchaseDate
                    }
                  }
                  totalQty
                }
              }
            }
          }
        }
      `,
      };

      const response = await getProductsNearbyStockService(stockInputValues);

      const { stores, totalQty, csBunitId } = response.data.data.getProductsNearbyStock;

      const currentStock = {
        csNearbyStoreId: "53F4FBEBDAB94C4AB205B7415EBD739E",
        name: tillData.tillAccess.csBunit.mWarehouse.name,
        nearbybUnitId: "EEF9FADCE0D74AE3B8B6096E6C35B6AA",
        viewStock: "Y",
        isIssue: "Y",
        warehouse: {
          mWarehouseID: tillData.tillAccess.csBunit.mWarehouse.mWarehouseID,
          name: tillData.tillAccess.csBunit.mWarehouse.name,
          value: "Central WH TTLLC",
          storageBin: {
            mStoragebinID: "09581CA09C154830A20B88370C501FD6",
            name: "Central Warehouse",
            stocks: [],
            totalQty: totalQty || 0,
          },
        },
      };

      const isStorePresent = stores?.some((store) => store?.nearbybUnitId === csBunitId);
      setStockList(isStorePresent ? stores : [currentStock, ...stores]);
    } catch (error) {
      console.error("Error fetching nearby stock:", error);
      message.error("Failed to fetch stock data");
    } finally {
      setStockLoading(false);
    }
  };

  const handleViewStockClick = (product) => {
    setSelectedStockProduct(product);
    setStockDrawerVisible(true);
    getProductNearByStock(product);
  };

  const currentWarehouseId = tillData?.tillAccess?.csBunit?.mWarehouse?.mWarehouseID;
  const filteredStockList = stockList?.filter((store) => {
    console.log("Comparing warehouse IDs:",stockList);
    const warehouseId = store?.warehouse?.mWarehouseID;
    return warehouseId && warehouseId !== currentWarehouseId;
  });

  const filterProducts = async (brands, categories, searchValue = "") => {
    try {
      let productsData = await db.products.filter((product) => product.isactive === true).toArray();
      if (brands.length > 0 || categories.length > 0 || searchValue) {
        productsData = productsData.filter((item) => {
          const matchesBrand = brands.length === 0 || brands.includes(item.brandId);
          const matchesCategory = categories.length === 0 || categories.includes(item.mProductCategoryId);
          const matchesSearch =
            !searchValue ||
            item.name.toLowerCase().includes(searchValue.toLowerCase()) ||
            item.value.toLowerCase().includes(searchValue.toLowerCase()) ||
            item.description.toLowerCase().includes(searchValue.toLowerCase());
          return matchesBrand && matchesCategory && matchesSearch;
        });
      }
      setProductsList(productsData);
      setDisplayedNonFrequentProducts(productsData.filter((item) => !item.isBestSeller).slice(0, ITEMS_PER_LOAD));
      setHasMoreNonFrequent(productsData.filter((item) => !item.isBestSeller).length > ITEMS_PER_LOAD);
    } catch (error) {
      console.error("Error filtering products:", error);
    }
  };

  const debouncedSearch = debounce((searchValue) => {
    filterProducts(selectedProductBrand, selectCategoryList, searchValue);
  }, 300);

  const debouncedBrandChange = debounce((brandId) => {
    const isSelected = selectedProductBrand?.includes(brandId);
    let updatedSelectedBrands = [];
    if (isSelected && selectedProductBrand?.length > 0) {
      updatedSelectedBrands = selectedProductBrand?.filter((id) => id !== brandId);
    } else {
      let tempBrand = selectedProductBrand || [];
      updatedSelectedBrands = [...tempBrand, brandId];
    }
    setSelectedProductBrand(updatedSelectedBrands || []);
    filterProducts(updatedSelectedBrands || [], selectCategoryList, productSearchInput);
  }, 300);

  const handleBrandCheckboxChange = (brandId) => {
    debouncedBrandChange(brandId);
  };

  const debouncedCategoryChange = debounce((checkedValues) => {
    setSelectCategoryList(checkedValues);
    filterProducts(selectedProductBrand, checkedValues, productSearchInput);
  }, 300);

  const handleCategoryCheckboxChange = (checkedValues) => {
    debouncedCategoryChange(checkedValues);
  };

  const handleButtonClick = (categoryId) => {
    let updatedCategories;
    if (categoryId === "ALL") {
      updatedCategories = [];
    } else {
      updatedCategories = selectCategoryList[0] === categoryId ? [] : [categoryId];
    }
    setSelectCategoryList(updatedCategories);
    filterProducts(selectedProductBrand, updatedCategories, productSearchInput);
  };

  const handleCategoryChange = (categoryId) => {
    setSelectCategoryList(categoryId ? [categoryId] : []);
    filterProducts(selectedProductBrand, categoryId ? [categoryId] : [], productSearchInput);
  };

  const tableComponents = {
    header: {
      cell: (props) => (
        <th
          {...props}
          style={{
            background: "#fff",
            borderBottom: "1px solid #E5E7EB",
            fontSize: "10px",
            fontWeight: 500,
            color: "#111827",
            padding: "4px 6px",
            height: "28px",
            lineHeight: "14px",
            whiteSpace: "nowrap",
            ...props.style,
          }}
        />
      ),
    },
    body: {
      cell: (props) => (
        <td
          {...props}
          style={{
            borderBottom: "1px solid #F3F4F6",
            fontSize: "11px",
            fontWeight: 400,
            color: "#374151",
            padding: "6px 6px",
            height: "26px",
            lineHeight: "14px",
            whiteSpace: "nowrap",
            ...props.style,
          }}
        />
      ),
    },
  };

const columns = [
  {
    title: "",
    render: (_, row) => (
      <Radio
        checked={selectedStockRow?.key === row?.key}
        onChange={() => setSelectedStockRow(row)}
      />
    ),
  },
  {
    title: "Outlet Name",
    dataIndex: "outletName",
    render: (text) => (
      <span
        style={{
          fontWeight: 500,
          fontSize: "12px",
          whiteSpace: "normal",
          wordBreak: "break-word",
          lineHeight: "14px",
        }}
      >
        {text}
      </span>
    ),
  },
  {
    title: "Batch Number",
    dataIndex: "batchNumber",
    render: (text) => (
      <span
        style={{
          fontSize: "12px",
          fontWeight: 400,
          whiteSpace: "normal",
          wordBreak: "break-word",
        }}
      >
        {text}
      </span>
    ),
  },
{
  title: "MRP",
  dataIndex: "mrp",
  key: "mrp",
  render: (v) => (
    <span style={{ fontSize: "12px" }}>
      {currenciesList[0]?.symbolRightSide === "N"
        ? currenciesList[0]?.currSymbol
        : ""}
      {Number(v ?? 0).toLocaleString()}
      {currenciesList[0]?.symbolRightSide === "Y"
        ? currenciesList[0]?.currSymbol
        : ""}
    </span>
  ),
},
{
  title: "Batch Rate",
  dataIndex: "batchRate",
  key: "batchRate",
  render: (v) => (
    <span style={{ fontSize: "12px" }}>
      {currenciesList[0]?.symbolRightSide === "N"
        ? currenciesList[0]?.currSymbol
        : ""}
      {Number(v ?? 0).toLocaleString()}
      {currenciesList[0]?.symbolRightSide === "Y"
        ? currenciesList[0]?.currSymbol
        : ""}
    </span>
  ),
},
  {
    title: "Stock",
    dataIndex: "qty",
    align: "center",
    render: (text) => (
      <span style={{ fontSize: "12px", fontWeight: 500, color: "#000" }}>
        {text}
      </span>
    ),
  },
  {
    title: "Unit",
    dataIndex: "unit",
    align: "center",
    render: (text) => (
      <span style={{ fontSize: "12px", fontWeight: 400, color: "#666" }}>
        {text}
      </span>
    ),
  },
];



  const handleStockTransferRequest = async () => {
if (!selectedStockRow) {
  return message.warning("Please select outlet");
}

if (!requestQty || requestQty < 1) {
  return message.warning("Enter valid quantity");
}

const totalQty = Number(selectedStockRow?.qty || 0);

if (requestQty > totalQty) {
  return message.warning(`Only ${totalQty} available in selected outlet`);
}

    // 🔥 RUN CONFIRM LOGIC DIRECTLY (no modal)
    const tillData = JSON.parse(localStorage.getItem("tillData"));

    const mutation = buildTransferRequestMutation({
      fromBunitId: selectedStockRow?.nearbybUnitId,
      toBunitId: tillData.tillAccess.csBunit.csBunitId,
      productId: selectedStockProduct?.mProductId,
      qty: requestQty,
      userId: tillData.tillAccess.csUserId,
    });

    try {
      const response = await generateTransferRequestService({ query: mutation });
      const result = response?.data?.data?.generateTransferRequest;

      if (result?.code === "200") {
        message.success(result.message);
        resetRequestFields(); // 👈 Clear dropdown & qty
        setStockDrawerVisible(false);
      } else {
        message.error(result?.message || "Transfer request failed");
      }
    } catch (err) {
      console.error(err);
      message.error("Something went wrong");
    }
  };

const transformedRows = [];

filteredStockList?.forEach((store) => {
  const warehouse = store?.warehouse;
  const stocks = warehouse?.storageBin?.stocks || [];

  stocks.forEach((stock) => {
    const qty = Number(stock?.qtyonhand || 0);
    if (qty <= 0) return;

    transformedRows.push({
      key: `${warehouse?.mWarehouseID}_${stock?.batch?.mBatchId}`,
        nearbybUnitId: store?.nearbybUnitId,
        warehouseId: warehouse?.mWarehouseID,
        batchId: stock?.batch?.mBatchId,
      outletName: store?.name,
      batchNumber: stock?.batch?.batchno || "-",
      qty,
      unit: stock?.product?.uom?.name || "pcs",

      // ✅ INLINE — FROM PRODUCT ONLY
      mrp:
        selectedStockProduct?.priceList?.[0]?.pricestd ??
        selectedStockProduct?.sunitprice ??
        selectedStockProduct?.slistprice ??
        0,

      batchRate:stock?.batch?.listPrice || 0,
    });
  });
});


const outletOptions = transformedRows.map((row) => ({
  value: row.key, // unique per batch
  label: `${row.outletName} - ${row.batchNumber}`,
}));

  const resetRequestFields = () => {
    setSelectedOutlet(null);
    setSelectedStockRow(null);
    setRequestQty("");
  };

  const handleSortChange = (value) => {
    console.log(`Sort by: ${value}`);
  };

  const onFilterClose = () => {
    setCategoriesData([]);
    setProductsList([]);
    setBrandsData([]);
    setSelectCategoryList([]);
    setSelectedProductBrand([]);
    setProductSearchInput("");
    setFilterDrawer(false);
    setLayoutName("default");
    setDisplayedNonFrequentProducts([]);
    setHasMoreNonFrequent(true);
    if (searchInputRef?.current) {
      searchInputRef?.current.focus();
    }
  };

  const onProductsClose = () => {
    setIsProductsVisible(false);
  };

  const handleScrollLoad = (event) => {
    const scrollEl = event.target;
    const maxScroll = scrollEl.scrollHeight - scrollEl.clientHeight;
    const currentScroll = scrollEl.scrollTop;

    if (Math.round(currentScroll) >= Math.round(maxScroll) - 100 && hasMoreNonFrequent) {
      const filtered = nonfrequentProducts.filter((product) => selectCategoryList.length === 0 || selectCategoryList.includes(product.mProductCategoryId));
      const lengthOff = displayedNonFrequentProducts.length;

      if (lengthOff < filtered.length) {
        clearTimeout(debounceTimeout.current);
        debounceTimeout.current = setTimeout(() => {
          const nextBatch = filtered.slice(lengthOff, lengthOff + ITEMS_PER_LOAD);
          setDisplayedNonFrequentProducts((prev) => [...prev, ...nextBatch]);
          if (lengthOff + nextBatch.length >= filtered.length) {
            setHasMoreNonFrequent(false);
          }
        }, 200);
      }
    }
  };

  const handleSearchEnter = () => {
    if (productSearchInput) {
      const exactMatch = productsList.find((product) => product.value.toLowerCase() === productSearchInput.toLowerCase());
      if (exactMatch) {
        pickProduct(exactMatch);
        setProductSearchInput("");
        debouncedSearch("");
        setOpen(false);
        const productSearchInputEl = document.getElementById("sm-product-search");
        if (productSearchInputEl) {
          productSearchInputEl.blur();
        }
        keyboard?.current?.setInput("");
      } else if (productsList.length > 0) {
        const firstProduct = productsList[0];
        pickProduct(firstProduct);
        setProductSearchInput("");
        debouncedSearch("");
        setOpen(false);
        const productSearchInputEl = document.getElementById("sm-product-search");
        if (productSearchInputEl) {
          productSearchInputEl.blur();
        }
        keyboard?.current?.setInput("");
      } else {
        message.warning("No products found for the search term.");
      }
    }
  };

  useEffect(() => {
    const scrollEl = scrollContainerRef.current?.view || scrollContainerRef.current?.container;
    if (scrollEl) {
      scrollEl.addEventListener("scroll", handleScrollLoad);
      return () => {
        scrollEl.removeEventListener("scroll", handleScrollLoad);
      };
    }
  }, [nonfrequentProducts, selectCategoryList, displayedNonFrequentProducts]);

  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
      debouncedBrandChange.cancel();
      debouncedCategoryChange.cancel();
    };
  }, []);

  return (
    <React.Fragment>
      {isProductsVisible ? (
        <>
          <CloseOutlined onClick={onProductsClose} style={{ fontSize: "1.2vw", cursor: "pointer", paddingLeft: "94vw", marginBottom: "1vh" }} />
          <Scrollbars className="productScroll1">
            {productsData.map((obj, i) => (
              <Row gutter={[15, 11]} style={{ width: "99%", backgroundColor: "#fff", marginTop: "1.5vh", height: "13vh", marginLeft: "-0.1vw", borderRadius: "10px" }}>
                <Col span={4}>
                  <img
                    style={{
                      width: "100%",
                      height: "11vh",
                      objectFit: "contain",
                      borderRadius: "5px",
                      paddingTop: "1vh",
                      alignSelf: "center",
                    }}
                    src={obj.imageurl || DefaultProductImage}
                    alt=""
                  />
                </Col>
                <Col span={16}>
                  <div style={{ maxWidth: "100%", overflow: "hidden", paddingTop: "1vh" }}>
                    <label style={{ ...data.posScreenStyles.productsCard.cardDetails.productDescr, whiteSpace: "nowrap", textOverflow: "ellipsis" }} className="productName">
                      {obj["description"]}
                    </label>
                  </div>
                  <p style={data.posScreenStyles.productsCard.cardDetails.superMarketProd} className="productName">
                    {obj["name"]}
                    <span style={{ display: "block" }}>{obj["value"]}</span>
                  </p>
                </Col>
                <Col span={4} style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
                  <span className="productDescription-kiosk" title={obj["description"]}>
                    {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                    {obj.sunitprice} {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}/{obj["uomName"]}
                  </span>
                  <span
                    onClick={() => {
                      pickProduct(obj);
                    }}
                    style={{ fontSize: "0.8em", color: "#fff", backgroundColor: "#2F3856", padding: "1vh 2.5vw", marginTop: "2%", borderRadius: "3px", cursor: "pointer" }}
                  >
                    ADD
                  </span>
                </Col>
                <span tabIndex={0}></span>
              </Row>
            ))}
          </Scrollbars>
        </>
      ) : null}
      <Drawer
        placement="bottom"
        closable={false}
        maskClosable={false}
        className="filter"
        bodyStyle={{ paddingBottom: 0, paddingTop: "10px", paddingLeft: "15px", paddingRight: "15px" }}
        onClose={onFilterClose}
        id="sm-drawer-close"
        height="100%"
        visible={filterDrawer}
      >
        {posConfig?.enableTileView === "Y" ? (
          <Col span={24} style={{ fontSize: "1vw", padding: "0 2vw", height: "100%" }}>
            {loading ? (
              <>
                {[...Array(12)].map((_, index) => (
                  <Card key={index} style={{ marginBottom: "1vh", padding: "12px", borderRadius: "8px" }}>
                    <Skeleton active paragraph={{ rows: 2 }} />
                  </Card>
                ))}
              </>
            ) : (
              <>
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <CloseOutlined onClick={onFilterClose} style={{ fontSize: "1.5vw", cursor: "pointer" }} />
                </div>
                <Row style={{ marginBottom: "2vh", width: "100%", display: "flex", alignItems: "center" }}>
                  <Col span={18}>
                    <Input
                      ref={productPanelSearchRef}
                      placeholder="Search for products by code/name"
                      id="sm-product-search"
                      onChange={(e) => {
                        const value = e.target.value;
                        setProductSearchInput(value);
                        keyboard?.current?.setInput(value);
                        debouncedSearch(value);
                      }}
                      style={{
                        borderRadius: "7px",
                        padding: "0.8vh 0.8vw",
                        borderColor: "#fff",
                        backgroundColor: "#fff",
                        height: "5vh",
                        fontSize: "1em",
                        marginTop: "-2vh",
                      }}
                      value={productSearchInput}
                      onFocus={() => {
                        setOpen(true);
                        setTimeout(() => {
                          setInputName("productSearch1");
                          keyboard?.current?.setInput(productSearchInput);
                        }, 150);
                      }}
                      onPressEnter={handleSearchEnter}
                      suffix={
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                          {productSearchInput?.length > 0 ? (
                            <CloseSquareFilled
                              style={{ fontSize: "20px", color: "#2F3856" }}
                              onClick={async () => {
                                setProductSearchInput("");
                                debouncedSearch("");
                                setTimeout(() => {
                                  setOpen(false);
                                  const productSearchInput = document.getElementById("sm-product-search");
                                  if (productSearchInput) {
                                    productSearchInput.blur();
                                  }
                                  keyboard?.current?.setInput("");
                                }, 200);
                              }}
                            />
                          ) : null}
                        </div>
                      }
                      prefix={<img src={SearchIcon} alt="" onClick={handleSelectProduct} style={{ cursor: "pointer" }} />}
                    />
                  </Col>
                  <Col span={5} style={{ marginLeft: "1vw" }}>
                    <Select
                      placeholder={<span style={{ fontSize: "1em", color: "#0F0718" }}>Sort By Latest</span>}
                      suffixIcon={<img src={MoreOptionsIcon} alt="" style={{ height: "1vh" }} />}
                      onChange={handleSortChange}
                      style={{
                        width: "100%",
                        height: "5vh",
                        borderRadius: "7px",
                        backgroundColor: "#fff",
                        fontSize: "1em",
                      }}
                    >
                      <Option key="discount" value="discount">
                        Price - low to high
                      </Option>
                      <Option key="parkBill" value="parkBill">
                        Price - high to low
                      </Option>
                      <Option key="popular" value="popular">
                        By Popular
                      </Option>
                      <Option key="discountPercent" value="discountPercent">
                        % off - high to low
                      </Option>
                    </Select>
                  </Col>
                </Row>
                <div style={{ display: "flex", overflowX: "auto", paddingBottom: "0.5%", paddingLeft: "0.1rem" }}>
                  <button
                    onClick={() => handleButtonClick("ALL")}
                    style={{
                      borderRadius: "5px",
                      border: "none",
                      background: selectCategoryList.length === 0 ? "#eff6ff" : "#f5f5f5",
                      color: selectCategoryList.length === 0 ? "#2563eb" : "#0F0718",
                      cursor: "pointer",
                      fontWeight: 500,
                      padding: "10px 15px",
                      height: "6vh",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      whiteSpace: "nowrap",
                      fontSize: "1em",
                      fontFamily: "Inter",
                    }}
                  >
                    ALL
                  </button>
                  {categoriesData
                    .slice()
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map((category) => (
                      <button
                        key={category.mProductCategoryId}
                        onClick={() => handleButtonClick(category.mProductCategoryId)}
                        style={{
                          background: selectCategoryList.includes(category.mProductCategoryId) ? "#eff6ff" : "#fff",
                          color: selectCategoryList.includes(category.mProductCategoryId) ? "#2563eb" : "#0F0718",
                          fontWeight: 500,
                          border: "none",
                          padding: "0.5vh 0.5vw",
                          height: "6vh",
                          borderRadius: "",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          whiteSpace: "nowrap",
                          fontSize: "1em",
                          fontFamily: "Inter",
                          cursor: "pointer",
                        }}
                      >
                        {category.name}{" "}
                        <Badge
                          count={categoryCounts[category.mProductCategoryId] || 0}
                          style={{
                            backgroundColor: "#f5f5f5",
                            color: "#0F0718",
                            fontSize: "0.8em",
                            padding: "0px 8px",
                            borderRadius: "10px",
                            marginLeft: "0.5em",
                          }}
                        />
                      </button>
                    ))}
                </div>
                <Scrollbars style={{ height: "75vh" }} ref={scrollContainerRef}>
                  <>
                    {frequentProducts.length > 0 && (
                      <div style={{ marginBottom: "2vh" }}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "3px",
                            marginBottom: "1vh",
                          }}
                        >
                          <h2 style={{ fontSize: "1.2em", fontWeight: 500, color: "#0F0718" }}>Best Sellers</h2>
                          <Badge
                            count={frequentProducts.length}
                            style={{
                              backgroundColor: "#f5f5f5",
                              color: "#0F0718",
                              fontSize: "0.8em",
                              padding: "0px 8px",
                              borderRadius: "10px",
                              marginBottom: "1vh",
                              marginTop: "2vh",
                            }}
                          />
                        </div>
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
                            gap: "12px",
                            paddingBottom: "0",
                          }}
                        >
                          {frequentProducts
                            .filter((product) => selectCategoryList.length === 0 || selectCategoryList.includes(product.mProductCategoryId))
                            .map((product) => (
                              <Card
                                key={product.mProductId}
                                style={{
                                  borderRadius: "10px",
                                  border: "1px solid #e0e0e0",
                                  cursor: "default",
                                  position: "relative",
                                  padding: "12px",
                                  overflow: "hidden",
                                  background: "#fff",
                                  boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                                  transition: "transform 0.2s ease, box-shadow 0.2s ease",
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.boxShadow = "0 4px 10px rgba(0,0,0,0.12)";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.08)";
                                }}
                              >
                                {/* Product Image Section */}
                                <div
                                  style={{
                                    height: "80px",
                                    background: "#f9f9f9",
                                    borderRadius: "8px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    marginBottom: "10px",
                                    position: "relative",
                                  }}
                                >
                                  <img
                                    src={product.imageurl || DefaultProductImage}
                                    alt={product.name}
                                    style={{
                                      width: product.imageurl ? "100%" : "40px",
                                      height: product.imageurl ? "100%" : "40px",
                                      objectFit: product.imageurl ? "cover" : "contain",
                                      borderRadius: "8px",
                                    }}
                                  />

                                  {product.isBestSeller && (
                                    <div
                                      style={{
                                        position: "absolute",
                                        top: "6px",
                                        right: "6px",
                                        backgroundColor: "#eab308",
                                        padding: "2px 6px",
                                        display: "flex",
                                        alignItems: "center",
                                        borderRadius: "10px",
                                        fontSize: "10px",
                                        fontWeight: 500,
                                        color: "#fff",
                                      }}
                                    >
                                      <StarOutlined style={{ fontSize: "10px", marginRight: "4px" }} />
                                      Best
                                    </div>
                                  )}
                                </div>

                                {/* Product Info Section */}
                                <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                                  {/* Product Name (Single Line with Tooltip) */}
                                  <Tooltip title={product.name}>
                                    <h3
                                      style={{
                                        fontSize: "0.85em",
                                        fontWeight: "600",
                                        color: "#0F0718",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        margin: 0,
                                      }}
                                    >
                                      {product.name}
                                    </h3>
                                  </Tooltip>

                                  {/* Variant or Value */}
                                  <div
                                    style={{
                                      fontSize: "0.8rem",
                                      color: "#6b7280",
                                      marginBottom: "0.25rem",
                                    }}
                                  >
                                    <span style={{ fontWeight: "500" }}>{product.value}</span>
                                  </div>

                                  {/* Price Display */}
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontSize: "0.9em",
                                        fontWeight: "700",
                                        color: "#16a34a",
                                      }}
                                    >
                                      {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                                      {product.sunitprice.toFixed(2)}
                                      {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}/{product.uomName}
                                    </span>
                                  </div>

                                  {/* Buttons */}
                                  <div style={{ textAlign: "center", marginTop: "8px" }}>
                                    <Button
                                      type="text"
                                      icon={<EyeOutlined />}
                                      style={{ color: "#8c8c8c", border: "1px solid #d9d9d9", fontSize: "0.8em", height: "30px", borderRadius: "6px", width: "100%" }}
                                      onClick={() => handleViewStockClick(product)}
                                    >
                                      View Stock
                                    </Button>
                                  </div>

                                  <Button
                                    type="primary"
                                    block
                                    style={{
                                      marginTop: "4px",
                                      fontSize: "0.8em",
                                      height: "30px",
                                      borderRadius: "6px",
                                      backgroundColor: "#2f3856",
                                    }}
                                    onClick={() => pickProduct(product)}
                                  >
                                    Add to Cart
                                  </Button>
                                </div>
                              </Card>
                            ))}
                        </div>
                      </div>
                    )}

                    {nonfrequentProducts.length > 0 && (
                      <div style={{ marginBottom: "2vh" }}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "3px",
                          }}
                        >
                          <h2 style={{ fontSize: "1.2em", fontWeight: 500, color: "#0F0718" }}>All Products</h2>
                          <Badge
                            count={nonfrequentProducts.length}
                            style={{
                              backgroundColor: "#f5f5f5",
                              color: "#0F0718",
                              fontSize: "0.8em",
                              padding: "0px 8px",
                              borderRadius: "10px",
                              marginBottom: "1vh",
                            }}
                          />
                        </div>
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
                            gap: "12px",
                          }}
                        >
                          {displayedNonFrequentProducts
                            .filter((product) => selectCategoryList.length === 0 || selectCategoryList.includes(product.mProductCategoryId))
                            .map((product) => (
                              <Card
                                key={product.mProductId}
                                style={{
                                  borderRadius: "10px",
                                  border: "1px solid #e0e0e0",
                                  cursor: "default",
                                  position: "relative",
                                  padding: "12px",
                                  overflow: "hidden",
                                  background: "#fff",
                                  boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                                  transition: "transform 0.2s ease, box-shadow 0.2s ease",
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.boxShadow = "0 4px 10px rgba(0,0,0,0.12)";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.08)";
                                }}
                              >
                                {/* Product Image Section */}
                                <div
                                  style={{
                                    height: "80px",
                                    background: "#f9f9f9",
                                    borderRadius: "8px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    marginBottom: "10px",
                                    position: "relative",
                                  }}
                                >
                                  <img
                                    src={product.imageurl || DefaultProductImage}
                                    alt={product.name}
                                    style={{
                                      width: product.imageurl ? "100%" : "40px",
                                      height: product.imageurl ? "100%" : "40px",
                                      objectFit: product.imageurl ? "cover" : "contain",
                                      borderRadius: "8px",
                                    }}
                                  />

                                  {product.isBestSeller && (
                                    <div
                                      style={{
                                        position: "absolute",
                                        top: "6px",
                                        right: "6px",
                                        backgroundColor: "#eab308",
                                        padding: "2px 6px",
                                        display: "flex",
                                        alignItems: "center",
                                        borderRadius: "10px",
                                        fontSize: "10px",
                                        fontWeight: 500,
                                        color: "#fff",
                                      }}
                                    >
                                      <StarOutlined style={{ fontSize: "10px", marginRight: "4px" }} />
                                      Best
                                    </div>
                                  )}
                                </div>

                                {/* Product Info Section */}
                                <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                                  {/* Product Name (Single Line with Tooltip) */}
                                  <Tooltip title={product.name}>
                                    <h3
                                      style={{
                                        fontSize: "0.85em",
                                        fontWeight: "600",
                                        color: "#0F0718",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        margin: 0,
                                      }}
                                    >
                                      {product.name}
                                    </h3>
                                  </Tooltip>

                                  {/* Variant or Value */}
                                  <div
                                    style={{
                                      fontSize: "0.8rem",
                                      color: "#6b7280",
                                      marginBottom: "0.25rem",
                                    }}
                                  >
                                    <span style={{ fontWeight: "500" }}>{product.value}</span>
                                  </div>

                                  {/* Price Display */}
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontSize: "0.9em",
                                        fontWeight: "700",
                                        color: "#16a34a",
                                      }}
                                    >
                                      {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                                      {product.sunitprice.toFixed(2)}
                                      {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}/{product.uomName}
                                    </span>
                                  </div>

                                  {/* Buttons */}
                                  <div style={{ textAlign: "center", marginTop: "8px" }}>
                                    <Button
                                      type="text"
                                      icon={<EyeOutlined />}
                                      style={{ color: "#8c8c8c", border: "1px solid #d9d9d9", fontSize: "0.8em", height: "30px", borderRadius: "6px", width: "100%" }}
                                      onClick={() => handleViewStockClick(product)}
                                    >
                                      View Stock
                                    </Button>
                                  </div>

                                  <Button
                                    type="primary"
                                    block
                                    style={{
                                      marginTop: "4px",
                                      fontSize: "0.8em",
                                      height: "30px",
                                      borderRadius: "6px",
                                      backgroundColor: "#2f3856",
                                    }}
                                    onClick={() => pickProduct(product)}
                                  >
                                    Add to Cart
                                  </Button>
                                </div>
                              </Card>
                            ))}
                        </div>
                        {hasMoreNonFrequent && (
                          <div style={{ textAlign: "center", padding: "16px" }}>
                            <Skeleton active paragraph={{ rows: 2 }} />
                          </div>
                        )}
                      </div>
                    )}

                    {frequentProducts.length === 0 && nonfrequentProducts.length === 0 && !loading && (
                      <div style={{ textAlign: "center", padding: "48px 0" }}>
                        <CompassFilled
                          style={{
                            fontSize: "64px",
                            color: "#bfbfbf",
                            marginBottom: "16px",
                          }}
                        />
                        <h3
                          style={{
                            fontSize: "1.2em",
                            fontWeight: "500",
                            color: "#0F0718",
                            marginBottom: "8px",
                          }}
                        >
                          No products found
                        </h3>
                        <p style={{ fontSize: "0.9em", color: "#4b5563" }}>Try adjusting your search or category filter</p>
                      </div>
                    )}
                  </>
                </Scrollbars>
              </>
            )}
          </Col>
        ) : (
          <Row style={{ padding: "0", height: "83vh", fontSize: "1vw" }}>
            <Col span={4}>
              <div style={{ paddingBottom: "2vh" }}>
                <Skeleton active loading={loading} paragraph={{ rows: 6 }}>
                  <div
                    style={{
                      height: "5vh",
                      backgroundColor: "rgba(146, 144, 152, 0.2)",
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "1vw",
                      borderTopLeftRadius: "5px",
                      borderTopRightRadius: "5px",
                    }}
                  >
                    <span style={{ color: "#0F0718", fontSize: "1em", fontWeight: 500 }}>Shop By Category</span>
                  </div>
                  <div style={{ backgroundColor: "#fff", height: "33vh", borderBottomLeftRadius: "5px", borderBottomRightRadius: "5px" }}>
                    <Scrollbars className="productCategorySuper">
                      <Checkbox.Group
                        style={{ padding: "1.5vh 1.5vw 0px 1.5vw", color: "#0F0718" }}
                        value={selectCategoryList}
                        options={categoriesData.map((category) => ({
                          label: <span style={{ color: "#0F0718", fontSize: "1em", fontWeight: 400, fontFamily: "Inter" }}>{category.name}</span>,
                          value: category.mProductCategoryId,
                        }))}
                        onChange={handleCategoryCheckboxChange}
                      />
                    </Scrollbars>
                  </div>
                </Skeleton>
              </div>
              <div>
                <Skeleton active loading={loading} paragraph={{ rows: 6 }}>
                  <div
                    style={{
                      height: "5vh",
                      backgroundColor: "rgba(146, 144, 152, 0.2)",
                      display: "flex",
                      alignItems: "center, paddingLeft: 1vw",
                      borderTopLeftRadius: "5px",
                      borderTopRightRadius: "5px",
                    }}
                  >
                    <span style={{ color: "#0F0718", fontSize: "1em", fontWeight: 500 }}>Brands</span>
                  </div>
                  <div style={{ backgroundColor: "#fff", height: "33vh", borderBottomLeftRadius: "5px", borderBottomRightRadius: "5px" }}>
                    <Scrollbars className="productCategorySuper">
                      {brandsData.map((item, i) => (
                        <div style={{ padding: "0.8vh 1.5vw 0px" }} key={i}>
                          <Checkbox
                            id={`sm-checkbox-${item.name}`}
                            checked={selectedProductBrand?.includes(item.brandId)}
                            onChange={() => handleBrandCheckboxChange(item.brandId)}
                          />
                          <span
                            onClick={() => handleBrandCheckboxChange(item.brandId)}
                            style={{
                              whiteSpace: "nowrap",
                              alignSelf: "center",
                              padding: "2px 10px",
                              fontSize: "1em",
                              backgroundColor: selectedProductBrand?.includes(item.brandId) ? "#2F3856" : "#fff",
                              borderRadius: "7px",
                              color: selectedProductBrand?.includes(item.brandId) ? "#fff" : "#0F0718",
                              cursor: "pointer",
                              fontFamily: "Inter",
                              fontWeight: 400,
                            }}
                          >
                            {item.name}
                          </span>
                        </div>
                      ))}
                    </Scrollbars>
                  </div>
                </Skeleton>
              </div>
            </Col>
            <Col span={19} offset={1} style={{ fontSize: "1vw" }}>
              {loading ? (
                <>
                  {[...Array(10)].map((_, index) => (
                    <React.Fragment key={index}>
                      <Skeleton.Button block />
                      <br />
                      <br />
                    </React.Fragment>
                  ))}
                </>
              ) : (
                <>
                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <CloseOutlined onClick={onFilterClose} style={{ fontSize: "1.2vw", marginTop: "-1vh", cursor: "pointer" }} />
                  </div>
                  <div style={{ display: "flex", width: "100%" }}>
                    <div style={{ width: "75%" }}>
                      <Input
                        ref={productPanelSearchRef}
                        placeholder="Search for products by code/name"
                        id="sm-product-search"
                        onChange={(e) => {
                          const value = e.target.value;
                          setProductSearchInput(value);
                          keyboard?.current?.setInput(value);
                          debouncedSearch(value);
                        }}
                        className="sm-product-search-panel"
                        style={{ borderRadius: "7px", padding: "0.8vh 0.8vw", borderColor: "#fff" }}
                        value={productSearchInput}
                        onFocus={() => {
                          setOpen(true);
                          setTimeout(() => {
                            setInputName("productSearch1");
                            keyboard?.current?.setInput(productSearchInput);
                          }, 150);
                        }}
                        onPressEnter={handleSearchEnter}
                        suffix={
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                            {productSearchInput?.length > 0 ? (
                              <CloseSquareFilled
                                style={{ fontSize: "20px", color: "#2F3856" }}
                                onClick={async () => {
                                  setProductSearchInput("");
                                  debouncedSearch("");
                                  setTimeout(() => {
                                    setOpen(false);
                                    const productSearchInput = document.getElementById("sm-product-search");
                                    if (productSearchInput) {
                                      productSearchInput.blur();
                                    }
                                    keyboard?.current?.setInput("");
                                  }, 200);
                                }}
                              />
                            ) : null}
                          </div>
                        }
                        prefix={<img src={SearchIcon} alt="" onClick={handleSelectProduct} style={{ cursor: "pointer" }} />}
                      />
                    </div>
                    <Select
                      className="selecItem"
                      placeholder={
                        <span style={{ paddingTop: "2em" }} className="cartSelect">
                          Sort By Latest
                        </span>
                      }
                      suffixIcon={<img src={MoreOptionsIcon} alt="" style={{ height: "1vh", marginBottom: "15%" }} />}
                      style={{ marginLeft: "1vw" }}
                    >
                      <Option className="cartOption" key="discount" value="discount">
                        Price - low to high
                      </Option>
                      <Option className="cartOption" key="parkBill" value="parkBill">
                        Price - high to low
                      </Option>
                      <Option className="cartOption" key="clearCart" value="clearCart">
                        By Popular
                      </Option>
                      <Option className="cartOption" key="clearCart" value="clearCart">
                        % off - high to low
                      </Option>
                    </Select>
                    <Button.Group style={{ width: "8%", height: "5vh", marginLeft: "0.6vw" }}>
                      <Button
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "3vw",
                          borderTopLeftRadius: "5px",
                          borderBottomLeftRadius: "5px",
                          margin: "0 0 0 0.5vw",
                          height: "inherit",
                          borderColor: "#fff",
                          backgroundColor: productsDisplay === "super-market" ? "#2F3856" : "",
                        }}
                      >
                        <img src={filterList} style={{ height: "2.3vh" }} />
                      </Button>
                      <Button
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "3vw",
                          borderTopRightRadius: "5px",
                          borderBottomRightRadius: "5px",
                          height: "inherit",
                          backgroundColor: productsDisplay === "superMarket" ? "#2F3856" : "",
                        }}
                      >
                        <img src={productsDisplay === "super-market" ? gridFilterInActive : gridFilter} style={{ height: "2.3vh" }} />
                      </Button>
                    </Button.Group>
                  </div>
                  <Scrollbars className="productScroll1">
                    {productsList.map((obj, i) => (
                      <Row
                        gutter={[15, 11]}
                        style={{ width: "99%", backgroundColor: "#fff", marginTop: "1.5vh", height: "13vh", marginLeft: "-0.1vw", borderRadius: "10px", fontSize: "1vw" }}
                      >
                        <Col span={4}>
                          <img
                            style={{
                              width: "100%",
                              height: "11vh",
                              objectFit: "contain",
                              borderRadius: "5px",
                              paddingTop: "1vh",
                              alignSelf: "center",
                            }}
                            src={obj.imageurl || DefaultProductImage}
                            alt=""
                          />
                        </Col>
                        <Col span={16}>
                          <div style={{ maxWidth: "100%", overflow: "hidden", paddingTop: "1vh" }}>
                            <label
                              style={{ ...data.posScreenStyles.productsCard.cardDetails.productDescr, whiteSpace: "nowrap", textOverflow: "ellipsis" }}
                              className="productName"
                            >
                              {obj["description"]}
                            </label>
                          </div>
                          <p style={data.posScreenStyles.productsCard.cardDetails.superMarketProd} className="productName">
                            {obj["name"]}
                            <span style={{ display: "block" }}>{obj["value"]}</span>
                          </p>
                        </Col>
                        <Col span={4} style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
                          <span className="productDescription-kiosk" title={obj["description"]}>
                            {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                            {obj.sunitprice} {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}/{obj["uomName"]}
                          </span>
                          <span
                            onClick={() => {
                              pickProduct(obj);
                            }}
                            style={{ fontSize: "0.8em", color: "#fff", backgroundColor: "#2F3856", padding: "1vh 2.5vw", marginTop: "2%", borderRadius: "3px", cursor: "pointer" }}
                          >
                            ADD
                          </span>
                        </Col>
                        <span tabIndex={0}></span>
                      </Row>
                    ))}
                  </Scrollbars>
                </>
              )}
            </Col>
          </Row>
        )}
      </Drawer>
      <Drawer
        headerStyle={{ background: "white", borderBottom: "none" }}
        bodyStyle={{ padding: "0.5rem", paddingTop: 0, background: "white" }}
        style={{ borderRadius: "15px" }}
        title={
          <div style={{ fontSize: "1.2em", fontWeight: "600", color: "#0F0718", fontFamily: "Inter", textAlign: "center", paddingTop: "20px" }}>
            {selectedStockProduct?.name || "Product Name"}
            <img
              src={Close || "/placeholder.svg"}
              onClick={() => {
                setStockDrawerVisible(false);
                setStockList([]);
                setSelectedStockProduct(null);
                setSelectedStockRow(null);
                setRequestQty(1);
                resetRequestFields();
              }}
              style={{
                position: "absolute",
                top: "50%",
                right: "1rem",
                transform: "translateY(-50%)",
                cursor: "pointer",
                width: "24px",
                height: "24px",
              }}
              alt="Close"
            />
          </div>
        }
        placement="right"
        closable={false} // Disable default close button
        onClose={() => {
          setStockDrawerVisible(false);
          setStockList([]);
          setSelectedStockProduct(null);
          setSelectedStockRow(null);
          setRequestQty(1);
          resetRequestFields();
        }}
        visible={stockDrawerVisible}
        width="70vw"
        maskStyle={{ backgroundColor: "#000000a6" }}
      >
        {stockLoading ? (
          <Skeleton active paragraph={{ rows: 4 }} />
        ) : selectedStockProduct ? (
          <div style={{ backgroundColor: "#fff", borderRadius: "8px", padding: "20px", position: "relative", height: "41vh", width: "100%", margin: "0 0% 1% 0%" }}>
            {stockList.length > 0 ? (
              <div>
                <div
                  style={{
                    border: "1px solid #D1D5DB",
                    borderRadius: "8px",
                    overflow: "hidden",
                    marginBottom: "20px",
                  }}
                >
                  <Table
                    dataSource={transformedRows}
                    columns={columns}
                    pagination={false}
                    components={tableComponents}
                    size="small"
                    bordered={false}
                    scroll={{ y: 250 }} // <= rows scroll only, header fixed
  rowClassName={(record) =>
    selectedStockRow?.key === record?.key ? "selected-row" : ""
  }
  onRow={(record) => ({
    onClick: () => setSelectedStockRow(record),
  })}
                    className="minimal-stock-table"
                  />
                </div>
              </div>
            ) : (
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center",
                  padding: "20px",
                  color: "#2F3856",
                  fontFamily: "Inter",
                }}
              >
                <h3 style={{ margin: 0, fontSize: "1.2em", fontWeight: 600 }}>No Stock Available</h3>

                <p style={{ marginTop: "8px", fontSize: "0.9em", color: "#6B7280" }}>This product has no stock in any warehouse.</p>
              </div>
            )}
            {selectedStockRow && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                width: "100%",
                marginBottom: "20px",
              }}
            >
              {/* LEFT PANEL */}
              <div
                style={{
                  flex: 1,
                  backgroundColor: "#F3F4F9",
                  borderRadius: "14px",
                  border: "1px solid #D9D9D9",
                  padding: "20px",
                }}
              >
                {/* TITLE ROW */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "10px",
                  }}
                >
                  <div style={{ fontSize: "1em", fontWeight: 500, color: "#0F0718" }}>Request Stock Transfer for {selectedStockProduct?.name || "Product Name"}</div>

                  {/* Qty label here */}
                  <div style={{ fontSize: "13px", fontWeight: 500, color: "#000", paddingRight: "4px" }}>Qty</div>
                </div>

                {/* DROPDOWN + QTY ROW */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "12px",
                    width: "100%",
                  }}
                >
                  {/* SELECT OUTLET */}
  {selectedStockRow.outletName} — {selectedStockRow.batchNumber}

                  {/* QTY BOX */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      border: "1px solid #D1D5DB",
                      backgroundColor: "#FFFFFF",
                      borderRadius: "8px",
                      height: "30px",
                      width: "90px",
                      padding: "0 8px",
                      justifyContent: "space-between",
                    }}
                  >
                    <input
                      inputMode="numeric"
                      pattern="[0-9]*"
                      min="1"
                      style={{
                        border: "none",
                        outline: "none",
                        width: "40px",
                        fontSize: "0.95em",
                        textAlign: "center",
                      }}
                      value={requestQty}
                      onChange={(e) => {
                        const v = e.target.value;
                        const num = v.replace(/\D/g, ""); // ensure only digits
                        setRequestQty(num === "" ? "" : Number(num));
                      }}
                    />

                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div style={{ cursor: "pointer", fontSize: "8px", userSelect: "none" }} onClick={() => setRequestQty((prev) => Number(prev || 0) + 1)}>
                        ▲
                      </div>
                      <div style={{ cursor: "pointer", fontSize: "8px", userSelect: "none" }} onClick={() => setRequestQty((prev) => Math.max(1, Number(prev) - 1))}>
                        ▼
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* REQUEST BUTTON */}
              <button
                onClick={handleStockTransferRequest}
                style={{
                  backgroundColor: "#f3f4f9",
                  color: "#0F0718",
                  border: "1px solid #d9d9d9",
                  padding: "12px 22px",
                  borderRadius: "8px",
                  fontSize: "0.9em",
                  fontWeight: "500",
                  height: "45px",
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                }}
              >
                Request Transfer
              </button>
            </div>
            )}
          </div>
        ) : (
          <p style={{ fontSize: "1em", color: "#6b7280", textAlign: "center", fontFamily: "Inter" }}>No product selected</p>
        )}
      </Drawer>
    </React.Fragment>
  );
};

export default ProductPanelSM;
